module.exports = __webpack_public_path__ + "media/images/thumbnails/thumbs_select-c99f37930e3a00244bc3438ad4276224.jpg";